__turbopack_context__.v({
  "navigationList": "NavigationList-module-scss-module__p82KwW__navigationList",
});
